import React from 'react';
import OText from 'components/CText/OText';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import CollapsibleComponent from 'components/CollapsibleContainer/CollapsibleContainer';
import './FrequentlyAskedQuestion.scss';

const FrequentlyAskedQuestionView = props => {
  const { frequentlyAskedQuestion, isExpanded } = props;

  return (
    <FlexContainer className="flex-column padB48 frequentlyAskedQuestion">
      <FlexContainer
        className={'bgNeutral005 margt20'}
        style={{ height: '20px' }}
      />
      <FlexContainer className={'padL48 padR48 m-padL16 m-padR16 flex-column '}>
        <Label className={'H4 mH5 margT40 m-margT20'}>
          {'Frequently asked questions'}
        </Label>
        {frequentlyAskedQuestion?.map(question => {
          return (
            <>
              <div className="margT16 bgWhite"></div>
              <FlexContainer className={'bgGray0 '}>
                <CollapsibleComponent
                  className={'width100'}
                  isExpanded={isExpanded}
                  contentTitle={
                    <Label className={'H5 mSubtitle-1 '} tabIndex="-1">
                      {question?.title}
                    </Label>
                  }
                >
                  <div className={'padL48 padR16 padB24'}>
                    <OText text={question?.body} />
                  </div>
                </CollapsibleComponent>
              </FlexContainer>
            </>
          );
        })}
      </FlexContainer>
    </FlexContainer>
  );
};

export default FrequentlyAskedQuestionView;
